import PropTypes from "prop-types";

import { PROXIMITY_BAND_COLORS } from "helpers/mapColors";

export function BandSwatch({ color }) {
  return (
    <span
      aria-hidden="true"
      className="tw:size-2.5 tw:rounded-full"
      style={{ backgroundColor: PROXIMITY_BAND_COLORS[color] }}
    />
  );
}

BandSwatch.propTypes = {
  color: PropTypes.oneOf(Object.keys(PROXIMITY_BAND_COLORS)).isRequired,
};
